export default {
  placeholder: 'Select a sensor',
};
